import { connect } from 'react-redux'
import AddToGroup from './add-to-group'
import { isOpen, getPupilsIds } from './add-to-group.selectors'
import { closeAddToGroupDialog } from './add-to-group.actions'

const getExcept = idsArray => {
  const result = {}
  idsArray.forEach(id => (result[id] = true))
  return result
}

const mapStateToProps = (state, { getGroups }) => {
  const ids = getPupilsIds(state)
  const except = ids.length === 1 ? getExcept(getGroups(state, ids[0])) : null
  return {
    title:
      ids.length === 1
        ? 'Add pupil to a group'
        : `Add ${ids.length} pupils to a group`,
    ids: ids,
    opened: isOpen(state),
    except
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  requestClose: () => dispatch(closeAddToGroupDialog()),
  onSubmit: ({ group }) => {
    dispatch(closeAddToGroupDialog())
    stateProps.ids.forEach(id => ownProps.action && ownProps.action(id, group))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(AddToGroup)
